/**
 * Form up on a leader.
 *
 * The primary selected aircraft leads and the rest take stations relative to
 * it, rotated to its heading. One reposition each — this is "form up", not
 * continuous station-keeping, so if the leader flies on you say it again.
 */

import { api, type ApiResult } from '@/api/client';

export type FormationKind =
  | 'v'
  | 'line-abreast'
  | 'echelon-right'
  | 'echelon-left'
  | 'column'
  | 'diamond';

export const FORMATION_LABEL: Record<FormationKind, string> = {
  v: 'V',
  'line-abreast': 'ABREAST',
  'echelon-right': 'ECH R',
  'echelon-left': 'ECH L',
  column: 'COLUMN',
  diamond: 'DIAMOND',
};

export interface FormUpOutcome {
  droneId: string;
  ok: boolean;
  code: string;
  message: string;
}

export interface FormUpResult {
  leaderId: string;
  formation: FormationKind;
  headingDeg: number;
  outcomes: FormUpOutcome[];
}

export function formUp(body: {
  leaderId: string;
  followerIds: string[];
  formation: FormationKind;
  spacingM: number;
}): Promise<ApiResult<FormUpResult>> {
  return api.post<FormUpResult>('/formation', body, {
    label: `FORM UP ${body.formation.toUpperCase()}`,
  });
}
